module.exports = __webpack_public_path__ + "static/logo2-ff84be9a20305c02e34c39e1e471e9f1.png";